var map = {
	"./AppleMusic.svg": 489,
	"./CopyLinkIcon.svg": 86,
	"./CopyLinkIcon2.svg": 196,
	"./Instagram.svg": 490,
	"./SoundCloud.svg": 491,
	"./Spotify.svg": 492,
	"./Tidal.svg": 493,
	"./TikTok.svg": 494,
	"./Twitter.svg": 495,
	"./Venmo.svg": 496,
	"./YouTube.svg": 497,
	"./activity-icon.svg": 498,
	"./add.svg": 499,
	"./addActive.svg": 79,
	"./affiliations.svg": 500,
	"./affiliationsActive.svg": 501,
	"./attach.svg": 502,
	"./badge.svg": 503,
	"./badges.svg": 197,
	"./cancel-upload.svg": 198,
	"./cheveron-down.svg": 78,
	"./close-arrow-accent.svg": 199,
	"./close-icon.svg": 504,
	"./comments-icon.svg": 259,
	"./connect.svg": 116,
	"./copy.svg": 200,
	"./createFolder.svg": 505,
	"./cross-icon.svg": 47,
	"./cross.svg": 165,
	"./customization.svg": 506,
	"./customizationActive.svg": 507,
	"./data-icon.svg": 260,
	"./deletePermanently.svg": 508,
	"./delete_forever.svg": 509,
	"./down-arrow.svg": 166,
	"./down-icon.svg": 120,
	"./down.svg": 96,
	"./download-share.svg": 107,
	"./download-shared-files-logo.svg": 510,
	"./download-shared-files.svg": 511,
	"./download.svg": 512,
	"./downloaded-white.svg": 201,
	"./downloads.svg": 513,
	"./duplicate.svg": 514,
	"./edit.svg": 202,
	"./electricBolt.svg": 261,
	"./email.svg": 203,
	"./expire.svg": 515,
	"./facebook.svg": 204,
	"./favourite.svg": 68,
	"./files-icon.svg": 262,
	"./folder.svg": 129,
	"./folderActive.svg": 71,
	"./icon-arrow-right.svg": 97,
	"./icon-document.svg": 516,
	"./image-preview.svg": 124,
	"./info.svg": 263,
	"./info_white.svg": 517,
	"./instagram-orange.svg": 518,
	"./integrations.svg": 519,
	"./integrationsActive.svg": 520,
	"./link-icon.svg": 264,
	"./link-playlist.svg": 205,
	"./lock-icon.svg": 521,
	"./login-background.svg": 522,
	"./loop.svg": 206,
	"./messanger.svg": 523,
	"./mic-icon.svg": 524,
	"./move.svg": 525,
	"./orange-filled-star.svg": 167,
	"./pause-play-circle.svg": 168,
	"./pause.svg": 169,
	"./pauseActive.svg": 526,
	"./pausePublic.svg": 93,
	"./pdf.svg": 265,
	"./permanentDelete.svg": 527,
	"./play.svg": 207,
	"./playActive.svg": 528,
	"./playIcon.svg": 208,
	"./playPublic.svg": 125,
	"./playlist-add.svg": 529,
	"./playlist-icon-white.svg": 209,
	"./playlist-icon.svg": 210,
	"./playlist-play-circle.svg": 211,
	"./playlist-tile.svg": 170,
	"./profile-img-accent.svg": 118,
	"./profile-img.svg": 266,
	"./profile.svg": 530,
	"./profileActive.svg": 531,
	"./recording.svg": 212,
	"./reload.svg": 532,
	"./restart.svg": 258,
	"./restore.svg": 533,
	"./rin.svg": 534,
	"./rocket.svg": 535,
	"./session.svg": 213,
	"./sessionCredit.svg": 126,
	"./share.svg": 214,
	"./signup-icon.svg": 130,
	"./soundexchange-icon.svg": 536,
	"./star-icon-outline.svg": 537,
	"./star-icon.svg": 538,
	"./star.svg": 539,
	"./subscription-active.svg": 540,
	"./subscription.svg": 541,
	"./trash-white.svg": 122,
	"./trash.svg": 95,
	"./twitter-orange.svg": 542,
	"./twitter-share.svg": 215,
	"./up-arrow.svg": 171,
	"./up-icon.svg": 119,
	"./upload.svg": 216,
	"./white-outline-star.svg": 54,
	"./youtube-orange.svg": 543
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92;